<div class="gb-dialog-header">
  @if (displayName()) {
    <h1 [translateParams]="getProfileName()" translate="SETTINGS.PAYMENTS.ADD_CARD_DIALOG.TITLE"></h1>
  } @else {
    <h1 translate="SETTINGS.PAYMENTS.ADD_CARD_DIALOG.TITLE_NO_NAME"></h1>
  }

  <button mat-dialog-close mat-icon-button><gb-icon icon="close"></gb-icon></button>
</div>

<div class="gb-dialog-content cards-outer-content">
  @if (emptyState$ | async) {
    @if (!addCard) {
      <div class="empty-state-container">
        <span translate="SETTINGS.PAYMENTS.ADD_CARD_DIALOG.NO_PAYMENT_METHODS"></span>
      </div>
    }
  } @else {
    <div class="cards-container">
      @for (paymentMethod of paymentMethods$ | async; track paymentMethod) {
        <div class="card">
          <div class="card-icon-container">
            <gb-card-icon [brand]="getCardBrand(paymentMethod.card)"></gb-card-icon>
          </div>
          <div class="card-labels">
            @for (label of getCardLabel(paymentMethod); track label) {
              <span>{{ label }}</span>
            }
            @if (isCardExpired(paymentMethod)) {
              <span class="expired-badge">Expired</span>
            }
          </div>
        </div>
      }
    </div>
  }
  @if (addCard && profile.uuid) {
    <div class="add-card-container">
      <gb-add-card [profileUuid]="profile.uuid"></gb-add-card>
    </div>
  }
</div>

<div class="gb-dialog-actions-container gb-flex-button-container">
  @if (addCard) {
    <button mat-stroked-button translate="CANCEL" (click)="cancelAddCard()"></button>
    <button mat-flat-button translate="SAVE" (click)="saveCard()"></button>
  } @else {
    <button mat-flat-button translate="SETTINGS.PAYMENTS.ADD_CARD_DIALOG.ADD_CARD" (click)="startAddCard()"></button>
  }
</div>
